import * as Actions from 'redux/actions'
import { useDispatch } from 'react-redux'
import { setFocusModeEnabled } from 'redux/actions/focusMode'

import { useRootStore } from 'stores/RootStore'
import { ALMANAC_CORE_WORKSPACE_ID } from 'utils/constants'
import { useAuth } from './UseAuth'
import { useQuery } from 'react-query'
import * as AppPreferencesClient from 'api/clients/AppPreferencesClient'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { UserAppPreferences } from 'types'

const DEFAULT_SETTINGS = {
  leftNavLocked: true,
  focusModeDisabled: false,
}

/**
 * Loads user preferences and set the sidebar state.
 *
 * @param workspaceId
 * @param loggedIn
 */
export const useUserPreferences = (workspaceId: number | undefined) => {
  const dispatch = useDispatch()
  const { notifications } = useRootStore()
  const auth = useAuth()
  const workspaceIdNormalized = workspaceId ?? ALMANAC_CORE_WORKSPACE_ID

  return useQuery<UserAppPreferences>(
    ['user-preferences', workspaceId],
    async () => {
      const res = await AppPreferencesClient.getUserAppPreferences(workspaceIdNormalized)

      if (res.type !== SUCCESS_RESPONSE_TYPE) throw new Error('Error fetching user preferences')

      return {
        ...DEFAULT_SETTINGS,
        ...res.data,
      }
    },
    {
      enabled: !!auth,
      staleTime: Infinity,
      onSuccess: (res) => {
        const { cardDismissals, wizardTourDismissal, focusModeDisabled, notificationsMutedAt } = res
        dispatch(Actions.setInitialSidebarState(false))
        dispatch(Actions.setCardDismissals(cardDismissals || []))
        dispatch(Actions.setWizardTourDismissals(wizardTourDismissal || []))
        dispatch(setFocusModeEnabled({ enableFocusMode: !focusModeDisabled }))
        notifications.setMutedAt(notificationsMutedAt ?? null)
      },
      onError: () => {
        dispatch(Actions.setInitialSidebarState(false))
        dispatch(Actions.setCardDismissals(['handbook_editor_footer']))
        dispatch(Actions.setWizardTourDismissals([]))
        dispatch(setFocusModeEnabled({ enableFocusMode: true }))
      },
    },
  )
}

export default useUserPreferences
